import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Table, TableCell, TableHeader, TableLoading } from 'advenio-components'
import moment from 'moment'
import ProfileHeader from '../ProfileHeader'
import HistoricalActions from '../../Data/Redux/HistoricalRedux'

const Container = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`

const TableContainer = styled.div`
  margin: 8px;
`
class History extends Component {
  componentWillMount() {
    const { studentId } = this.props
    this.props.getHistory(studentId)
  }
  render() {
    const { history, loading } = this.props
    return (
      <Container>
        <ProfileHeader
          header="Historial del Alumno"
          noSave
        />
        <TableContainer>
        {loading ?
          <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Fecha',
                  element: 'Text',
                  maxWidth: 200,
                  center: true,
                },
                {
                  id: 2,
                  header: 'Motivo',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: 'Comentario',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={4}
            />:
          <Table
            data={history}
            roundedCorners
            columns={[
              {
                Header: () => <TableHeader title="Fecha" center blue />,
                accessor: 'created_at',
                Cell: ({ value }) => <TableCell center noEllipsis>{moment(value).format('DD MMM YYYY HH:mm:ss')}</TableCell>,
              },
              {
                Header: () => <TableHeader title="Motivo" center blue />,
                accessor: 'type',
                Cell: ({ value }) => <TableCell center noEllipsis>{value}</TableCell>,
              },
              {
                Header: () => <TableHeader title="Comentario" center blue />,
                accessor: 'comments',
                Cell: ({ value }) => <TableCell center noEllipsis >{value}</TableCell>,
                
              },
            ]}
          />
        }
        </TableContainer>
      </Container>
  )}
}
History.propTypes = {
  history: PropTypes.array.isRequired,
  getHistory: PropTypes.func.isRequired,
  studentId: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
}
History.defaultProps = {
  history: [],
  studentId: null,
  loading: false,
}
const mapStateToProps = state => ({
  history: state.historical.get.results,
  loading: state.historical.get.fetching,
})

const mapDispatchToProps = dispatch => ({
  getHistory: (studentId) => dispatch(HistoricalActions.getRequest({studentId}, true)),
})

export default connect(mapStateToProps, mapDispatchToProps)(History)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/History.jsx